import { render, staticRenderFns } from "./popContentSider.vue?vue&type=template&id=379bc5ec&scoped=true"
import script from "./popContentSider.vue?vue&type=script&setup=true&lang=js"
export * from "./popContentSider.vue?vue&type=script&setup=true&lang=js"
import style0 from "./popContentSider.vue?vue&type=style&index=0&id=379bc5ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379bc5ec",
  null
  
)

export default component.exports